/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2021
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import CheckGroups from './CheckGroups';
import ChecksWithoutGroup from './ChecksWithoutGroup';

const CardList = props => {
  const {
    checks,
    managerMode,
    setSelectedCheck,
    selectedItem,
    checkFilters,
    storeInfo,
    onHandleSms,
    updateOrderStatus,
    deviceGroup,
    currentMode,
    viewGuestLocationOnMap,
    onOrderDelivered,
  } = props;

  const showGroupBy = true;

  return (
    <>
      {showGroupBy && (
        <CheckGroups
          checks={checks}
          setSelectedCheck={setSelectedCheck}
          selectedItem={selectedItem}
          managerMode={managerMode}
          checkFilters={checkFilters}
          storeInfo={storeInfo}
          onHandleSms={onHandleSms}
          updateOrderStatus={updateOrderStatus}
          deviceGroup={deviceGroup}
          currentMode={currentMode}
          viewGuestLocationOnMap={viewGuestLocationOnMap}
          onOrderDelivered={onOrderDelivered}
        />
      )}
      {!showGroupBy && (
        <ChecksWithoutGroup
          checks={checks}
          setSelectedCheck={setSelectedCheck}
          selectedItem={selectedItem}
          storeInfo={storeInfo}
          onHandleSms={onHandleSms}
          updateOrderStatus={updateOrderStatus}
          deviceGroup={deviceGroup}
          currentMode={currentMode}
          viewGuestLocationOnMap={viewGuestLocationOnMap}
          onOrderDelivered={onOrderDelivered}
        />
      )}
    </>
  );
};

export default CardList;

CardList.propTypes = {
  checks: PropTypes.array.isRequired,
  managerMode: PropTypes.bool,
  setSelectedCheck: PropTypes.func,
  selectedItem: PropTypes.object,
  checkFilters: PropTypes.object,
  storeInfo: PropTypes.object,
  onHandleSms: PropTypes.func,
  updateOrderStatus: PropTypes.func,
  deviceGroup: PropTypes.object,
  currentMode: PropTypes.string,
  viewGuestLocationOnMap: PropTypes.func,
  onOrderDelivered: PropTypes.func,
};

CardList.defaultProps = {
  checks: [],
  managerMode: false,
  setSelectedCheck: () => { },
  selectedItem: {},
  checkFilters: {},
  storeInfo: {},
  onHandleSms: () => { },
  updateOrderStatus: () => { },
  deviceGroup: null,
  currentMode: '',
  viewGuestLocationOnMap: () => { },
  onOrderDelivered: () => { },
};
